<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data UserPic" subTitle="Forms" />

    <CreateUserPic />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import CreateUserPic from "@/components/Pages/Data/UserPic/CreateUserPic.vue";

export default defineComponent({
  name: "CreateUserPicPage",
  components: {
    PageTitle,
    CreateUserPic,
  },
});
</script>
